import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import * as constants from '../config/constants/AppConstants';
import { OptionsConstants as options } from '../config/constants/OptionsConstants';

dayjs.extend(utc);
dayjs.extend(timezone);

const monthShort = options.variables.months.th.sn;

const monthOptions = options.months.default.options;

const DEBUG = constants.AppSettings.DEBUG;

export const isObject = (value) => {
    return (
      value !== null &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      Object.keys(value).length > 0
    );
  };

export const isEmpty = (value) => {
    return value === undefined || value === null || value === "" || value === 'null';
};

export const renderText = (value) => {
    return value;
}

export const truncateText = (text, maxLength = 100) => {
    if (typeof text !== 'string') return '';
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength).trim() + '...';
};


export const renderOption = (value, optionName) => {
    const optList = options[optionName]?.default?.options; // Avoid variable conflict

    if (!optList) return value; // If optionName is invalid, return value

    const matchedOption = optList.find(option => option.value.toString() === value.toString());

    return matchedOption ? matchedOption.label : value;
};

/** 

export const sampleText = (value) => {
    if (!value) return '';
    return value.length > 70 ? `${value.slice(0, 70)}...` : value;
}

export const renderOptionDB = (value, optionList, matchKey = "id", labelKey = "name") => {
    if (!Array.isArray(optionList)) return '-';

    const matchedOption = optionList.find(option => option[matchKey]?.toString() === value?.toString());

    return matchedOption ? matchedOption[labelKey] : value;
};
*/

export const formatLabel = (prefix = null, input, postfix = null, size="md") => {
  const isRequired = input?.validator?.required === true;

  return (
    <label className={`form-label ${size === 'sm' ? 'label-size-sm' : ''}`}>
      {prefix && <>{prefix}</>}
      {input?.label}
      {postfix && <>{postfix}</>}
      {isRequired && (
        <i
          className="fa-classic fa-light fa-asterisk fa-fw"
          style={{ fontSize: '0.5rem', verticalAlign: 'text-top' }}
          aria-hidden="true"
        ></i>
      )}
    </label>
  );
};

export const formatTextDescription = (text, classInline = '') => {
  if (!text) return null;

  return (
    <div
      className={`mt-1 ${classInline}`}
      dangerouslySetInnerHTML={{
        __html: text.replace(/\n/g, '<br />'),
      }}
    />
  );
};


export const formatNumber = (value, options = false) => {
    if (!value && !options) return "";

    let strValue = String(value);

    let num = Number(strValue);
    if (isNaN(num)) {
        return ""; 
    }

    if (strValue.endsWith(".") || /\.\d{0,1}$/.test(strValue)) {
        return strValue;
    }

    num = Number(strValue);

    if (options === true && num === 0) {
        return "0";
    }

    if (strValue.includes(".")) {
        return num.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });
    }

    return num.toLocaleString("en-US");
};


export const getYearRangeBEObjects = () => {
    const currentYearAD = new Date().getFullYear();
    const endYearBE = currentYearAD + 11 + 543;
    const startYearBE = currentYearAD - 70 + 543;
    const years = [];
  
    for (let year = endYearBE; year >= startYearBE; year--) {
      years.push({ id: year.toString(), name: year.toString() });
    }
  
    return years;
};

export const getYearRangeBEObjectsPrevious = () => {
    const currentYearAD = new Date().getFullYear();
    const endYearBE = currentYearAD + 0 + 543;
    const startYearBE = currentYearAD - 30 + 543;
    const years = [];
  
    for (let year = endYearBE; year >= startYearBE; year--) {
      years.push({ id: year.toString(), name: year.toString() });
    }
  
    return years;
};

export const convertDateToAD = (dmy, includeTime = false) => {
    if (!dmy || dmy === "1900-01-01T00:00:00.000Z") {
        return "";
    }

    const date = dayjs.utc(dmy).tz("Asia/Bangkok");
    let formattedDate = date.format("YYYY-MM-DD");

    if (includeTime) {
        const time = date.format("HH:mm");
        return `${formattedDate} ${time}`;
    }

    if(formattedDate === 'Invalid Date'){ formattedDate = '';}
    return formattedDate;
};

export const convertDateToBE = (dmy, includeTime = false) => {
    if (!dmy || dmy === "1900-01-01T00:00:00.000Z") {
        return "";
    }

    const date = dayjs.utc(dmy).tz("Asia/Bangkok");
    const day = date.format("DD");
    const month = date.format("MM");
    const yearBE = date.year() + 543;

    if (includeTime) {
        const time = date.format("HH:mm");
        return `${day}/${month}/${yearBE} ${time}`;
    }

    return `${day}/${month}/${yearBE}`;
};

export const convertDateToTextBE = (dmy, includeTime = false) => {
    if (!dmy || dmy === "1900-01-01T00:00:00.000Z") {
        return "";
    }

    const date = dayjs.utc(dmy).tz("Asia/Bangkok"); 
    const day = date.date(); 
    const month = options.variables.months.th.sn[date.month()];
    const yearBE = date.year() + 543;

    if (includeTime) {
        const time = date.format("HH:mm");
        return `${day} ${month} ${yearBE} ${time}`;
    }

    return `${day} ${month} ${yearBE}`;
};

export const combineLocalThaiAddress = ({ no, village_no, alley, road }) => {
    const parts = [];
  
    if (no) parts.push(`เลขที่ ${no}`);
    if (village_no) parts.push(`หมู่ ${village_no}`);
    if (alley) parts.push(`ซอย ${alley}`);
    if (road) parts.push(`ถนน ${road}`);
  
    return parts.join(' ');
  };
  

export const formatThaiAddress = ({ address, province_name, district_name, subdistrict_name, zip_code }) => {
    if (!province_name) return address || ''; 

    const isBangkok = province_name === 'กรุงเทพมหานคร';

    const districtLabel = isBangkok ? 'เขต' : 'อำเภอ';
    const subdistrictLabel = isBangkok ? 'แขวง' : 'ตำบล';
    const provinceLabel = isBangkok ? province_name : `จังหวัด${province_name}`;

    const parts = [];

    if (address) parts.push(address);
    if (subdistrict_name) parts.push(`${subdistrictLabel}${subdistrict_name}`);
    if (district_name) parts.push(`${districtLabel}${district_name}`);
    parts.push(provinceLabel);

    if (zip_code) parts.push(`รหัสไปรษณีย์${zip_code}`);

    return parts.join(' ');
}

export const generatePassword = (length = 8) => {
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
  
    const allChars = lowercase + uppercase + numbers;
  
    let password = '';
    
    password += lowercase[Math.floor(Math.random() * lowercase.length)];
    password += uppercase[Math.floor(Math.random() * uppercase.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
  
    for (let i = password.length; i < length; i++) {
      password += allChars[Math.floor(Math.random() * allChars.length)];
    }
  
    password = password.split('').sort(() => 0.5 - Math.random()).join('');
  
    return password;
}

export const parseDate = (dateStr) => {
    if (typeof dateStr !== 'string' || !dateStr.includes('/')) {
        return null;
    }

    const parts = dateStr.split('/').map(str => str.trim());

    if (parts.length !== 3 || parts.some(part => !part)) {
        return null;
    }

    let [day, month, year] = parts;
    day = String(parseInt(day));

    return {
        day,
        month,
        year: year.slice(-2),
        fullYear: year,
    };
}

export const displayDateRange = (start, end) => {
    const isValidDate = (date) =>
      date && date.day && date.month && date.year;

    const formatDate = (date) => {
      const month = monthShort[Number(date.month) - 1];
      return `${date.day} ${month} ${date.year}`;
    };

    const hasStart = isValidDate(start);
    const hasEnd = isValidDate(end);

    if (hasStart && hasEnd) {
      const startMonth = monthShort[Number(start.month) - 1];
      const endMonth = monthShort[Number(end.month) - 1];

      if (
        start.day === end.day &&
        start.month === end.month &&
        start.year === end.year
      ) {
        return `${start.day} ${startMonth} ${start.year}`;
      }

      if (start.month === end.month && start.year === end.year) {
        return `${start.day} - ${end.day} ${startMonth} ${start.year}`;
      }

      if (start.year === end.year) {
        return `${start.day} ${startMonth} - ${end.day} ${endMonth} ${start.year}`;
      }

      return `${start.day} ${startMonth} ${start.year} - ${end.day} ${endMonth} ${end.year}`;
    } else if (hasStart) {
      return formatDate(start);
    } else if (hasEnd) {
      return formatDate(end);
    }

    return '';
};


export const displayMonthYearRange = (row, startMonthKey, startYearKey, endMonthKey, endYearKey) => {
    const startMonthLabel = monthOptions.find(
      m => m.value === String(row[startMonthKey])
    )?.label || '';

    const endMonthLabel = monthOptions.find(
      m => m.value === String(row[endMonthKey])
    )?.label || '';

    const startYear = row[startYearKey] || '';
    const endYear = row[endYearKey] || '';

    if (startMonthLabel === endMonthLabel && startYear === endYear) {
      return `${startMonthLabel} ${startYear}`;
    }

    if (startYear === endYear) {
      return `${startMonthLabel} - ${endMonthLabel} ${endYear}`;
    }

    if (startMonthLabel === endMonthLabel) {
      return `${startMonthLabel} ${startYear} - ${endYear}`;
    }

    return `${startMonthLabel} ${startYear} - ${endMonthLabel} ${endYear}`;
};

export const printText = (text, underline = true) => (
    <span className={`${underline ? 'underline-placeholder' : ''} ms-2 me-2`}>
      {text ? ` ${text} ` : '-----'}
    </span>
);

export const getPdfOptions = (filename, id) => {
  return {
    margin: [10, 0, 10, 0], 
    filename: `${filename}_${id}.pdf`,
    image: { type: 'jpeg', quality: 1 },
    html2canvas: { 
        scale: 4,
        useCORS: true,
        allowTaint: false
    },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    pagebreak: { mode: ['css', 'legacy'] }
  };
};

export const numberToThaiText = (num) => {
  const txtNumArr = ["ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า"];
  const txtDigitArr = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

    function convertIntegerPart(number) {
    const txtNumArr = ["ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า"];
    const txtDigitArr = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน"];
    
    let result = '';
    const numStr = number.toString();
    const len = numStr.length;

    const sections = [];
    let current = '';

    for (let i = len - 1, count = 0; i >= 0; i--, count++) {
        current = numStr[i] + current;
        if ((count + 1) % 6 === 0 || i === 0) {
        sections.unshift(current);
        current = '';
        }
    }

    sections.forEach((section, index) => {
        let text = '';
        for (let i = 0; i < section.length; i++) {
        const digit = parseInt(section[i]);
        const pos = section.length - i - 1;

        if (digit !== 0) {
            if (pos === 1 && digit === 1) {
            text += 'สิบ';
            } else if (pos === 1 && digit === 2) {
            text += 'ยี่สิบ';
            } else if (pos === 0 && digit === 1 && section.length > 1) {
            text += 'เอ็ด';
            } else {
            text += txtNumArr[digit];
            text += txtDigitArr[pos];
            }
        }
        }

        if (text !== '') {
        if (index < sections.length - 1) text += 'ล้าน';
        result += text;
        }
    });

    return result || txtNumArr[0];
    }


  function convertDecimalPart(satang) {
    if (satang === '00') return 'ถ้วน';

    let satangText = '';
    for (let i = 0; i < satang.length; i++) {
      const digit = parseInt(satang[i]);
      const position = satang.length - i - 1;

      if (digit !== 0) {
        if (position === 1 && digit === 1) {
          satangText += 'สิบ';
        } else if (position === 1 && digit === 2) {
          satangText += 'ยี่สิบ';
        } else if (position === 0 && digit === 1 && satang.length > 1) {
          satangText += 'เอ็ด';
        } else {
          satangText += txtNumArr[digit];
          satangText += txtDigitArr[position];
        }
      }
    }

    return satangText + 'สตางค์';
  }

  num = num.toString().replace(/,/g, '');
  if (isNaN(num)) return '';

  const [baht, satang = '00'] = (+num).toFixed(2).split('.');
  const bahtText = convertIntegerPart(baht) + 'บาท';
  const satangText = convertDecimalPart(satang);

  return bahtText + satangText;
}

export const calculateNumberOfDays = (startDateStr, endDateStr) => {
    const start = new Date(startDateStr);
    const end = new Date(endDateStr);

    const diffTime = end - start;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // includes both start and end

    return diffDays;
};

export const formatMoneyRange = (startValue, endValue) => {
    const hasStart = startValue != null && startValue !== '';
    const hasEnd = endValue != null && endValue !== '';

    if (!hasStart && !hasEnd) return '';

    let start = parseFloat(startValue);
    let end = parseFloat(endValue);

    if (hasStart && hasEnd && start > end) {
        [start, end] = [end, start]; // swap
    }

    if (hasStart && hasEnd) {
        return `${formatNumber(start)} - ${formatNumber(end)}`;
    } else if (hasStart) {
        return `${formatNumber(start)}`;
    } else {
        return `${formatNumber(end)}`;
    }
}

export const debug = (state, actionName, details) => {
    if(DEBUG){
        if (details !== undefined) {
            console.log(`🚀 [DEBUG] ${actionName}`, state, details);
        } else {
            console.log(`🚀 [DEBUG] ${actionName}`, state);
        }
    }
};
